/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RiskOverviewCategory,
  RiskOverviewCategory$inboundSchema,
} from "./riskoverviewcategory.js";
import {
  RiskRuleBreakdownEntry,
  RiskRuleBreakdownEntry$inboundSchema,
} from "./riskrulebreakdownentry.js";

export type RiskUserBreakdownResult = {
  /**
   * Category breakdown for this user, ordered by finding count descending.
   */
  categories: Array<RiskOverviewCategory>;
  /**
   * External user the breakdown is scoped to.
   */
  externalUserId: string;
  /**
   * Total findings for this user in the window.
   */
  findings: number;
  /**
   * Inclusive start of the window used.
   */
  from: Date;
  /**
   * Rule_id breakdown for this user, ordered by finding count descending.
   */
  rules: Array<RiskRuleBreakdownEntry>;
  /**
   * Exclusive end of the window used.
   */
  to: Date;
};

/** @internal */
export const RiskUserBreakdownResult$inboundSchema: z.ZodMiniType<
  RiskUserBreakdownResult,
  unknown
> = z.pipe(
  z.object({
    categories: z.array(RiskOverviewCategory$inboundSchema),
    external_user_id: z.string(),
    findings: z.int(),
    from: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    rules: z.array(RiskRuleBreakdownEntry$inboundSchema),
    to: z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
  }),
  z.transform((v) => {
    return remap$(v, {
      "external_user_id": "externalUserId",
    });
  }),
);

export function riskUserBreakdownResultFromJSON(
  jsonString: string,
): SafeParseResult<RiskUserBreakdownResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskUserBreakdownResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskUserBreakdownResult' from JSON`,
  );
}
